import { render, staticRenderFns } from "./WcLoadersInfiniteNoResults.vue?vue&type=template&id=747e97b9&lang=pug&"
import script from "./WcLoadersInfiniteNoResults.vue?vue&type=script&lang=js&"
export * from "./WcLoadersInfiniteNoResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports